<template>
    <div>
        <div class="modal-header py-2 pt-3"  style="background: #162C4D;">
            <h5 class="text-white">{{$ml.get('CREATE_ACTION_V2')}}</h5>
            <button type="button" id="closeActivity" class="close pb-3 pt-2" style="color: #8092AB;" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" class="font-40">&times;</span>
            </button>
        </div>

        <div class="modal-section">
            <ul class=" nav hpx-50 px-3 mincrm-dynamic-tabs" id="newActivityTabMenu" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" id="activity-tab" data-toggle="tab" :href="'#activityA_'+parentComp" role="tab" aria-controls="deal" aria-selected="true">{{$ml.get('CREATE_ACTIVITY')}}</a>
                </li>
            </ul>
        </div>
        <div class="modal-body pt-2" id="activity-header">
            <div class="tab-content" id="newActivityTabContent">
                <div class="tab-pane fade show active py-2" :id="'activityA_'+parentComp" role="tabpanel" aria-labelledby="activity-tab">
                    <div class="row">
                        <div class="col-12 p-0 tabletSlide">
                            <div class="col-12 activitiesType mb-20" v-if="!listenStateStatus">
                                <button class="btn btn-click py-1" @click="activityTypes('call')" :class="{active:activities['type']===1}">{{$ml.get('CALL')}}</button>
                                <button class="btn btn-click py-1" @click="activityTypes('task')" :class="{active:activities['type']===3}">{{$ml.get('TASK')}}</button>
                                <button class="btn btn-click py-1" @click="activityTypes('meeting')" :class="{active:activities['type']===2}">{{$ml.get('APPOINTMENT')}}</button>
                                <button class="btn btn-click py-1" @click="activityTypes('email')" :class="{active:activities['type']===4}">{{$ml.get('E_MAIL')}}</button>
                            </div>
                            <div class="col-12 activitiesType d-flex justify-content-between" v-else>
                                <label class="new-label mt-1">{{$ml.get('TYPE_ACTIVITY')}}:</label>
                                <button class="btn btn-click py-1 active">{{activityType(activities['type'], $ml)}}</button>
                            </div>
                        </div>

                        <div class="col-md-6">

                            <!-- AKTİVİTE KONUSU -->
                            <div class="row">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('ACTIVITY_SUBJECT')}}</label>
                                    <input type="text" v-model="activitySubject" class="new-input">
                                </div>
                            </div>

                            
                            <!-- ATAYAN -->
                            <div class="row">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('ASSIGNMENT')}}*</label>
                                    <button type="button" class="h-36 bg-white select-button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {{assignedValueTitle}}
                                    <i class="fa fa-angle-down pull-right ml-2"></i>
                                    </button>
                                    <div class="dropdown-menu dropdown-menu-left multiChoose p-0">
                                        <ul class="new-dropdown p-0 border-0">
                                            <template v-for="u in users" :key="u && u._id ? u._id.$oid : u.name">
                                                <li v-if="u && (u.x || (u._id && u._id.$oid == assignedValue))" @click="assignedValue=u._id.$oid,assignedValueTitle=u.name+' '+u.surName" :disabled="!u.x" :class="{'active-user':!u.x}">{{u.name}} {{u.surName}}</li>
                                            </template>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            

                            <!-- ATANAN -->
                            <div class="row">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('ASSIGNED')}}*</label>
                                    <button type="button" class="h-36 bg-white select-button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {{assignedToValueTitle}}
                                    <i class="fa fa-angle-down pull-right ml-2"></i>
                                    </button>
                                    <div class="dropdown-menu dropdown-menu-left multiChoose p-0">
                                        <ul class="new-dropdown p-0 border-0">
                                            <template v-for="u in users" :key="u && u._id ? u._id.$oid : u.name">
                                                <li v-if="u && u.x" @click="assignedToValue=u._id.$oid,assignedToValueTitle=u.name+' '+u.surName">{{u.name}} {{u.surName}}</li>
                                            </template>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </div>

                        
                        <div class="col-md-6">
                            <div class="row mb-20">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('NOTE')}}</label>
                                    <textarea v-model="activityNote" id="activityNoteID" class="new-textarea w-100 mb-2" cols="30" rows="9" placeholder="Not Giriniz..."></textarea>
                                </div>
                            </div>
                        </div>

                    </div>

                    <hr>

                    <p class="font-family-bold mb-0" style="color: #7F8FA4;">{{$ml.get('PLANNING_DATE')}}</p>

                    <!-- fromCreationDate kısmı -->
                    <div class="row mb-4 d-flex align-items-center">
                        <div class="col-md-5">
                            <input type="radio" id="fromCreationDate" @click="fromCreationDateSection" value="fromCreationDate" v-model="pickedActivityDate">
                            <label class="ml-2 mt-2" style="word-spacing: 2px;" for="fromCreationDate">{{$ml.get('AFTER_THE_CREATION_OF_ACTIVITY')}}</label>
                        </div>
                        <div class="col-md-5 ml-3">
                            <div class="row" id="fromCreationDateSectionID" style="pointer-events: none;">
                                <div class="row">
                                    <div class="col-sm-3">
                                        <label class="new-label mb-1">{{$ml.get('DAY')}}</label>
                                        <input type="number" v-model="activityDelayDay" placeholder="0" style="height: 34px;" class="new-input mb-2" />
                                    </div>
                                    <div class="col-sm-3">
                                        <label class="new-label mb-1">{{$ml.get('HOUR')}}</label>
                                        <input type="number" v-model="activityDelayHour" placeholder="0" style="height: 34px;" class="new-input mb-2" />
                                    </div>
                                    <div class="col-sm-3">
                                        <label class="new-label mb-1">{{$ml.get('MINUTE')}}</label>
                                        <input type="number" v-model="activityDelayMinute" placeholder="0" style="height: 34px;" class="new-input mb-2" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- predefinedDate kısmı -->
                    <div class="row mb-4">
                        <div class="col-md-3">
                            <input type="radio" id="predefinedDate" @click="predefinedDateSection" value="predefinedDate" v-model="pickedActivityDate">
                            <label class="ml-2 mt-2 text-dark" style="word-spacing: 2px;" for="predefinedDate">{{$ml.get('ON_A_PREDEFINED_DATE')}}</label>
                        </div>
                        <div class="col-md-6">
                            <div class="row" id="predefinedDateSectionID" style="pointer-events: none;">
                                <div class="col-sm-6 mb-2">
                                    <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" id="activityDateWorkflow" :label="$ml.get('SELECT_DATE')" class="new-ctk" v-model="activityDateWorkflow" format="YYYY-MM-DD" formatted="ll" :noLabel="true" :range="false" :onlyDate="true" :auto-close="true"></vue-ctk-date-time-picker>
                                    
                                </div>
                                <div class="col-sm-4">
                                    <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" id="activityTime2" :label="$ml.get('TIME')" v-model="activityTime2" class="new-ctk" format="HH:mm" formatted="HH:mm"  :noLabel="true" :range="false" :onlyTime="true"></vue-ctk-date-time-picker>
                                </div>
                            </div>
                        </div>

                    </div>

                    <hr>

                    <div class="row">
                        <div class="col-md-12">
                            <label class="mr-3 mt-2" style="font-weight: bold; color: #7F8FA4;">{{$ml.get('TIME')}}</label>
                            <div class="d-flex align-items-center row">
                                <div class="col-md-5">
                                    <p style="margin: 0; word-spacing: 2px;">{{$ml.get('SPECIFY_THE_REQUIRED_TIME_FOR_ACTIVITY')}}</p>
                                </div>
                                <div class="ml-0 col-md-2">
                                    <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" id="activityTime1" :label="$ml.get('TIME')" v-model="activityTime1" class="new-ctk" format="HH:mm" formatted="HH:mm" :noLabel="true" :range="false" :onlyTime="true"></vue-ctk-date-time-picker>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
                <div class="tab-pane fade py-2" :id="'reminderA_'+parentComp" role="tabpanel" aria-labelledby="reminder-tab">
                    <div v-if="listenStateStatus">
                        <reminderPanel :reminders="reminders"  @updateRemindersData="updateRemindersData" @successUpsert="getRemindersF()" :activityId="activityId" />
                    </div>
                    <div v-else>
                        <reminderPanel :reminders="reminders"  @updateRemindersData="updateRemindersData" />
                    </div>
                </div>
                <div class="tab-pane fade py-2" :id="'customFieldA_'+parentComp" role="tabpanel" aria-labelledby="customField-tab">
                    <div class="w-100" v-show="customFieldArray.length>0">
                        <special-area type="save" ref="customFields" :domain="domain" :edit="listenStateStatus" @returnCustomData="returnCustomData($event)" :editArray="$store.state.editLine" :user="user" postField="activity" :users="users" @returnCustomField="returnCustomField=$event" :active="customFieldActive" :customFieldType="customFieldType" :customField="customFieldArray" :allcustomFieldArray="customFieldArray"></special-area>
                    </div>
                </div>
            </div>
            
            <div class="row pt-4 crm-modal-footer stickyBtn">
                <hr class="col-12 d-none d-md-block mt-0"/>
                <div class="col-12 dealBtnStyle" v-if="listenStateStatus===false">
                    <button class="btn-new save" id="activityProceed" aria-label="Close" @click="activityProceed()">{{$ml.get('PROCEED_V2')}}</button> 
                    <button @click="closeButton" class="btn-new">{{$ml.get('CANCEL')}}</button>  
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import axios from 'axios'
import Vue from 'vue'
import {mapState} from 'vuex'
import {mapActions} from 'vuex'
import {mapGetters} from 'vuex'
import specialArea from '@/components/customField'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
Vue.component('vue-ctk-date-time-picker', VueCtkDateTimePicker)
import reminderPanel from '@/components/reminderPanel'


import _ from 'underscore'
import { duration } from 'moment'

export default {
    name: 'workflowActivity',
    data () {
        return {
            activityArr: [],
            activities:{},
            activitySubject: '',
            activityNote: '',

            planningDate: {},
            fromCreationDate: {},
            timeNumber: '',
            timeAfter: '',
            activityTime1:"",
            predefinedDate: {},
            activityDelayDay: "",
            activityDelayHour: "",
            activityDelayMinute: "",

            activityId:"",
            returnCustomField:[],
            activityTypeText:"",
            activityDateWorkflow:"",
            createDate:"",
            activityTime2:"",
            activityPeriod:"00:00",
            selectedDone:false,
            organizationKeyword:"",
            contactKeyword:"",
            dealKeyword:"",
            selectOrganization:"",
            selectContact:"",
            selectDeal:"",
            isHiddenOrganization:false,
            isHiddenContact:false,
            isHiddenDeal:false,
            items:[],
            organizationId:"",
            contactId:"",
            dealId:"",
            methods:"save",
            assignedToValueTitle:"Seçiniz",
            assignedToValue:"",
            assignedValueTitle:"Seçiniz",
            assignedValue:"",
            specialArray:[],
            customFieldType:1,
            customFieldActive:false,
            notes:[],
            selected:"",
            updateNote:[],
            activitiesNote:[],
            customFieldArray:[],
            domain:6,
            domains:[5,6,7,8],
            languagetr:{
                language: 'Türkçe', 
                months: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'], 
                monthsAbbr: ['Ock','Şbt', 'Mrt', 'Nsn', 'Mays', 'Hazi', 'Tem', 'Ağs', 'Eyl', 'Ekm', 'Ksm', 'Arlk'], 
                days: ['P', 'PT', 'S', 'Ç', 'P', 'C', 'CT'], 
                rtl: false, 
                ymd: 'yyyy-MM-dd', 
                yearSuffix: ''
            },
            addOrg:false,
            addOrgArray:{'isCandidate':true},
            addContact:false,
            addContactArray:[],
            isNewOrganization:false,
            customerType:[
                {value: true, label: this.$ml.get('LEAD')},
                {value: false, label: this.$ml.get('CUSTOMER')},
            ],
            reminders:[
                {
                    day:'',
                    time:'12:00',
                    date:{$date:''},
                    isActive:true,
                    isQueued:false
                }
            ],

            pickedActivityDate: '',
            
        }
    },
    computed: {
        ...mapState([
            'baseUrl',
            'editLine',
            'editLineStatu'
        ]),
        ...mapGetters(['localeLang']),
        listenState() { return this.$store.state.editLine },
        listenStateStatus() { return this.$store.state.editLineStatu },
    },
    components:{
        'special-area':specialArea,
        'reminderPanel':reminderPanel
    },
    props:["data","user","users","contactOrg","clearModal","permission","parentComp","updateAction"],
    methods:{
        activityType:function (type,ml){
            const mlInst = ml || this.$ml;
            var activityTypeMap={ 1:mlInst.get('CALL'),2:mlInst.get('APPOINTMENT'),3:mlInst.get('TASK'),4:mlInst.get('E_MAIL')}
            return activityTypeMap[type] || ''
        },

        fromCreationDateSection(){
            console.log('fromCreationDate')
            $('#fromCreationDateSectionID').css('pointer-events', 'auto')
        },

        predefinedDateSection(){
            console.log('predefinedDate')
            $('#predefinedDateSectionID').css('pointer-events', 'auto')
        },
        
        updateRemindersData(newReminders){
            this.reminders = newReminders
        },
        getRemindersF(){
            var form = {}
            form.activityId = this.activityId
            this.getReminders(form).then((res)=>{return res}).then((res)=>{
                console.log("getReminders res")
                console.log(res)
                if(res.status.code=='0'){
                    var remindersMutation = res.content.reminders.filter(r => {
                        return r.isActive==true&&r.date!==null
                    })
                    remindersMutation.forEach(r => {
                        if(r.day==undefined && r.date.$date!==undefined){
                            r.day = this.$moment(r.date.$date).format('YYYY-MM-DD')
                        }
                        if(r.time==undefined && r.date.$date!==undefined){
                            r.time = this.$moment(r.date.$date).format('HH:mm')
                        }
                    })
                    this.reminders = remindersMutation
                }
            })
        },
        returnCustomData(data){
            data['edit']=true
            this.$store.dispatch('editLine', data)
        },
        addNoteF(noteObj){
            this.notes.push(noteObj)
        },
        returnNote(event){
            this.activities['note']=event
        },
        permissionSet(){
            if(this.permission===true){
                this.$notify({ 
                    group: 'foo',
                    type: 'error', 
                    title: this.$ml.get('ERROR'),
                    text: this.$ml.get('YOU_ARE_NOT_AUTHORIZED')
                })
                return true
            }else{
                return false
            }
        },
        getCustomFields(){
            axios({
                method:'POST',
                url:`/getCustomFields`,
                baseURL: this.baseUrl,
                data:{
                    domain:this.domain
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data.status.code==0){
                    this.customFieldArray = res.data.content.customFields
                }                    
            })
        },
        activityTypes(type){
            let types=[]
            if(type==='call'){
                types["call"]=this.$ml.get('CALL'),
                this.activities["type"]=1
                this.customFieldType=1
                this.domain=6
            }else if(type==='task'){
                types["task"]=this.$ml.get('TASK'),
                this.activities["type"]=3
                this.customFieldType=3
                this.domain=5
            }else if(type==='meeting'){
                types["meeting"]=this.$ml.get('APPOINTMENT'),
                this.activities["type"]=2
                this.customFieldType=2
                this.domain=8
            }else if(type==='email'){
                types["email"]=this.$ml.get('E_MAIL'),
                this.activities["type"]=4
                this.customFieldType=4
                this.domain=7
            }
            this.activityTypeText=types[type]
            this.getCustomFields()
        },


        activityProceed(){
            
            if(this.activitySubject === '' || this.activitySubject === undefined){
                this.$notify({ 
                    group: 'foo',
                    type: 'warn', 
                    title: this.$ml.get('WARNING'),
                    text: this.$ml.get('PLEASE_ENTER_A_SUBJECT')
                })

                return false
            }

            if(this.assignedValue === "0"){
                this.$notify({ 
                    group: 'foo',
                    type: 'warn', 
                    title: this.$ml.get('WARNING'),
                    text: this.$ml.get('PLEASE_SELECT_AN_ASSIGNER')
                })

                return false
            }

            if(this.assignedToValue === "0"){
                this.$notify({ 
                    group: 'foo',
                    type: 'warn', 
                    title: this.$ml.get('WARNING'),
                    text: this.$ml.get('PLEASE_SELECT_AN_ASSIGNEE')
                })

                return false
            }

            if(this.pickedActivityDate !== '' || this.pickedActivityDate !== undefined){
                if((this.timeNumber && this.timeAfter === '') || (this.timeNumber === '' && this.timeAfter)){
                    this.$notify({ 
                        group: 'foo',
                        type: 'warn', 
                        title: this.$ml.get('WARNING'),
                        text: 'Lütfen aktivitenin oluşturulma tarihi kısımlarını eksiksiz giriniz.'
                    })
    
                    return false
                }
            }else{
                this.$notify({ 
                    group: 'foo',
                    type: 'warn', 
                    title: this.$ml.get('WARNING'),
                    text: 'Lütfen gerekli tarih kısımlarını giriniz.'
                })

                return false
            }

            let date = {}
            let emptyDate = ''
            let activityObject = {}

            if((this.activityDateWorkflow == '') && (this.activityDelayDay == "" && this.activityDelayHour == "" && this.activityDelayMinute == "")){
                // console.log('Tarihler boşş')
                // date = emptyDate
                // activityObject.delay_date_for_rindap = date
            }else if(this.activityDelayDay != "" || this.activityDelayHour != "" || this.activityDelayMinute != ""){

                const day = Math.floor(this.activityDelayDay * 1440);
                const hour = Math.floor(this.activityDelayHour * 60);
                const minute = Math.floor(this.activityDelayMinute);
                date = day + hour + minute
                activityObject.dueDatebyTime = date

            }else if(this.activityDateWorkflow != ''){
                const activityDateWorkflowVal = new Date(this.activityDateWorkflow)
                const workflowActivityDate = moment(activityDateWorkflowVal).format('DD MMMM YYYY')
                const dateString = workflowActivityDate.concat(' ', this.activityTime2, ' UTC')
                const event = new Date(dateString);
                const dueDateString = event.toISOString()
                
                date = {
                    $date: dueDateString
                }
                activityObject.dueDate = date
            }

            // console.log('date')
            // console.log(date)

            if(this.activityTime1 != ''){
                activityObject.duration = this.activityTime1
            }

            activityObject.subject = this.activitySubject,
            activityObject.note = this.activityNote,
            activityObject.assignor = {
                $oid: this.assignedValue
            },  
            activityObject.assignedTo = {
                $oid: this.assignedToValue
            },
            
            activityObject.type = this.activities["type"]

            this.$emit('change',activityObject)
            this.activitySubject = ''
            this.activityNote = ''
            this.assignedToValueTitle = "Seçiniz"
            this.assignedValueTitle = "Seçiniz"
            this.activityTypes('call')
            this.pickedActivityDate = ''
            this.timeNumber = ''
            this.timeAfter = ''

            $('#addAction').modal('hide')

            this.$emit('closeBtnActivity')

        },


        saveButton(){
            if(this.activities['done']===undefined){
                this.activities['done']=false
            }
            if(this.activities['subject']===undefined){
                this.$notify({ 
                    group: 'foo',
                    type: 'warn', 
                    title: this.$ml.get('WARNING'),
                    text: this.$ml.get('SUBJECT_CANNOT_BE_BLANK')
                })
                return false
            }

            if(this.assignedToValue==="0"){
                this.$notify({ 
                    group: 'foo',
                    type: 'warn', 
                    title: this.$ml.get('WARNING'),
                    text: this.$ml.get('ASSIGMENT_NOT_DONE')
                })
                return false
            }else{
                this.activities["assignedTo"]={"$oid":this.assignedToValue}
            }
            if(this.listenStateStatus){
                if(this.assignedValue==="0"){
                    this.$notify({ 
                        group: 'foo',
                        type: 'warn', 
                        title: this.$ml.get('WARNING'),
                        text: this.$ml.get('ASSIGNER_NOT_SELECTED')
                    })
                    return false
                }else{
                    this.activities["assignor"]={"$oid":this.assignedValue}
                }
            }
            
            if(this.organizationId!=""){
                let obj ={}
                obj["$oid"]=this.organizationId
                this.activities["orgId"]=obj
            }
            if(this.contactId!="" && this.contactKeyword!=""){
                let obj ={}
                obj["$oid"]=this.contactId
                this.activities["contactId"]=obj
            }else{
                this.activities["contactId"]=""
            }

            if(this.dealId!=""){
                let obj ={}
                obj["$oid"]=this.dealId
                this.activities["dealId"]=obj
            }else{
                this.activities["dealId"]=""
            }
            if(this.activities["note"]===""){
                delete this.activities["note"]
            }

            for (var customId in this.returnCustomField){
                if (typeof this.returnCustomField[customId] !== 'function') {
                    this.activities[customId] = this.returnCustomField[customId]
                }
            }
            
            if(this.listenStateStatus===false){
                let url = "addActivity"
                let dataObj={}
                dataObj["activityInputObj"]=this.activities
                this.postActivities(url,dataObj)
            }else{
                let url = "updateActivity"
                let dataObj={}
                dataObj["objId"]=this.activityId
                dataObj["updateObj"]=this.activities
                this.postActivities(url,dataObj)
            }
            
        },
        saveContactButton(){
            let name="",
            surName,phone,url,mail;
            let nameSplit = []
            let dataObj={}
            nameSplit = this.addContactArray['name'].split(" ")
            if(nameSplit.length-1>0){
                for (let index = 0; index < nameSplit.length-1; index++) {
                    name=name+" "+nameSplit[index]
                }
                surName=nameSplit[nameSplit.length-1]
            }else{
                name=nameSplit[0]
            }
            phone=this.addContactArray['gsm']
            mail=this.addContactArray['mail']

            if(name.length>0 && mail!=null && phone!=null ){
                if(phone.length<9){
                    this.$notify({ 
                        group: 'foo',
                        type: 'warning', 
                        title: this.$ml.get('WARNING'),
                        text: this.$ml.get('PHONE_NUMBER_SHOULD_BE_AT_LEAST_10_DIGITS')
                    })
                }
                else if(!this.validEmail(mail)){
                    return false
                }else{ 
                    url = "addContact"
                    dataObj["contactInputObj"]={"n":name,"sn":surName,"gsm":phone,"email":mail}
                    this.postContact(url,dataObj)
                }
            }else{
                this.$notify({ 
                    group: 'foo',
                    type: 'warning', 
                    title: this.$ml.get('WARNING'),
                    text: this.$ml.get('REQUIRED_FIELDS_CANNOT_BE_BLANK')
                })
            }
        },
        postContact(url,obj){
             
            axios({
                method:'POST',
                url:`/${url}`,
                baseURL: this.baseUrl,
                data: obj,
                withCredentials:true
            }).then((res)=>{
                    return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('NEW_CONTACT_ADDED'),
                        text: res.data.status.desc 
                    })
                    this.isHiddenContact = false
                    this.addContact=false
                    this.addContactArray['gsm']=""
                    this.contactId=res.data.content.contact._id.$oid
                    this.selectContact=res.data.content.contact.n
                    this.items=[]
                    this.isNewOrganization=true
                     
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('WARNING'),
                        text: res.data.status.desc 
                    })
                     
                }
            })
        },
        closeContactButton(){
            this.addOrg=false
            this.addContact=false
            this.addContactArray['gsm']=""
            this.addContactArray['mail']=""
        },
        saveOrgButton(){
            let url =""
            let obj ={}
            let dataObj={}
            let phone=[]
            if(this.addOrgArray['name'].length>1){
                obj["name"]=this.addOrgArray['name']
            }else{
                this.$notify({ 
                    group: 'foo',
                    type: 'warn', 
                    title: 'Firma adı boş olamaz!',
                })
                return false
            }
            if(this.addOrgArray['phone'].length>9){
                phone.push(this.addOrgArray['phone'])
                obj["phoneNumbers"] = phone
            }else{
                this.$notify({ 
                    group: 'foo',
                    type: 'warn', 
                    title: this.$ml.get('WARPHONE_COMPANY_LEAST_10_DIGITSNING'),
                })
                return false
            }
            obj["isCandidate"]=this.addOrgArray['isCandidate']
            obj["status"]=true
            url = "addOrganization"
            dataObj["organizationInputObj"]=obj
            this.postOrganization(url,dataObj)
        },
        validEmail: function (email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if(email.length>0&&email!==undefined){
                if(re.test(email)===false){
                    this.$notify({ group: 'foo',
                        type: 'warn', 
                        title: this.$ml.get('INVALID_EMAIL'),
                        text: this.$ml.get('PLEASE_INSERT_A_VALID_EMAIL')
                    })
                    return false
                }else{
                    return email
                }
            }else{
                return false
            }
        },
        postOrganization(url,obj){
             
            axios({
                method:'POST',
                url:`/${url}`,
                baseURL: this.baseUrl,
                data: obj,
                withCredentials:true
            }).then((res)=>{
                    return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('NEW_COMPANY_ADDED'),
                        text: res.data.status.desc 
                    })
                    this.addOrgArray['phone']=""
                    this.addOrg=false
                    this.isNewOrganization=true
                    this.organizationKeyword=res.data.content.organization.name
                    this.isHiddenOrganization= false
                    this.organizationId=res.data.content.organization._id.$oid
                    this.selectOrganization=res.data.content.organization.name
                     
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                     
                }
            })
        },

        closeOrgButton(){
            this.addOrg=false
            this.addContact=false
            this.addOrgArray['phone']=""
            this.isHiddenContact=false
        },
        relationButton(){
            this.addOrganizationContact()
        },
        relationCancelButton(){
            this.isNewOrganization=false
        },
        addOrganizationContact(){
             
            axios({
            method:'POST',
            url:'/addOrganizationContact',
            baseURL: this.baseUrl,
            data: {
                objId:this.organizationId,
                newContactId:this.contactId
            },
            withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data.status.code==0){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('COMPANY_AND_CONTACT_ASSOCIATED'),
                        text: res.data.status.desc 
                    })
                    this.isNewOrganization=false
                     
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                     
                }
            })
        },
        convertHtml(value){
            if(this.isHTML(value)){
                return $(value).html()
            }else{
                return value
            }
        },
        definedNot(index,value){
            this.updateNote[index]=value
        },
        isHTML(str) {
            var doc = new DOMParser().parseFromString(str, "text/html");
            return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
        },
        deleteCommit(index,notId){
             
            axios({
                method:'POST',
                url:'/upsertActivityNote',
                baseURL: this.baseUrl,
                data: {
                    activityId:this.activityId,
                    noteText:'',
                    activityNoteId:notId
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data.status.code==0){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('SUCCESS_NOTE_HAS_BEEN_DELETED'),
                        text: res.data.status.desc
                    })
                    this.selected=""
                    this.notes.splice(index,1);
                     
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'warning', 
                        title: this.$ml.get('WARNING'),
                        text: res.data.status.desc
                    })
                     
                }
            })
        },
        noteUpdate(index,not,notId){
             
            not = '<p>'+not+'</p>'
            axios({
                method:'POST',
                url:'/upsertActivityNote',
                baseURL: this.baseUrl,
                data: {
                    activityId:this.activityId,
                    noteText:not,
                    activityNoteId:notId
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data.status.code==0){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('SUCCESSFUL'),
                        text: res.data.status.desc
                    })
                    this.selected=""
                    this.notes[index]=res.data.content.note
                     
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'warning', 
                        title: this.$ml.get('WARNING'),
                        text: res.data.status.desc
                    })
                     
                }
            })
        },
        postActivities(url,obj){
            if(this.$route.path==="/dealCard/"+this.$route.params.dealId){
                if(this.permissionSet()){
                    return false
                }
            }
             
            axios({
                method:'POST',
                url:`/${url}`,
                baseURL: this.baseUrl,
                data: obj,
                withCredentials:true
            }).then((res)=>{
                    return res
            }).then((res)=>{
                console.log("res postActivities")
                console.log(res)
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==="0"){
                    if(this.listenStateStatus===false){
                        this.$notify({ 
                            group: 'foo',
                            type: 'success', 
                            title: this.$ml.get('NEW_ACTIVITY_ADDED'),
                            text: res.data.status.desc 
                        })

                        this.upsertRemindersF(res.data.content.activity._id.$oid)
                        this.activitiesNote=""
                        this.$emit('refleshData') 
                        $('#add').modal('hide')
                        $('#addActivity').modal('hide')
                        if(this.data===undefined){
                            this.clear()
                        }else{
                            this.clearMethod2()
                        }
                    
                    this.$emit('getData',res.data.content.activities)
                    }else{
                        $('#add').modal('hide')
                        $('#addActivity').modal('hide')
                        this.$notify({ 
                            group: 'foo',
                            type: 'success', 
                            title: this.$ml.get('ACTIVITY_UPDATE'),
                            text: res.data.status.desc 
                        })
                        this.$emit('refleshData') 
                       
                    }
                   
                     
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                     
                }
            })
        },
        formatUpsertList(originalList,activityId){
            
            const keys = ['date','isActive','isQueued']

            const result = array => array.map( o => keys.reduce((acc,curr)=>{
                acc[curr] = o[curr]
                acc.activityId = {}
                acc.activityId.$oid = activityId
                return acc
            },{}))
            return result(originalList)
        },
        upsertRemindersF(activityId){
            var remindersMutation = this.reminders.filter(r => { return r.date.$date!==''})
            if(remindersMutation.length>0){
                var form = {}
                form.objs = this.formatUpsertList(remindersMutation,activityId)
                this.upsertReminder(form).then((res)=>{return res}).then((res)=>{
                    console.log("upsertReminder res")
                    console.log(res)
                    if(res.status.code!=='0'){
                        this.$notify({ 
                            group: 'foo',
                            type: 'warning', 
                            title: this.$ml.get('WARNING'),
                            text: res.status.desc 
                        })
                    }
                })
            }
        },
        closeButton(){
            console.log('Aktivite İptal');
            this.activitySubject = ''
            this.activityNote = ''
            this.assignedToValueTitle = "Seçiniz"
            this.assignedValueTitle = "Seçiniz"
            this.activityTypes('call')
            this.pickedActivityDate = ''
            this.timeNumber = ''
            this.timeAfter = ''


            this.$emit('closeBtn')
            $("#add").modal("hide")
            $("#addActivity").modal("hide")
            if(this.data===undefined){
                this.clear()
            }else{
                this.clearMethod2()
                let statu=false
                this.$store.dispatch('editLineStatu', statu)
            }
        },
        clearMethod2(){
            this.assignedToValueTitle=this.$ml.get('SELECT')
            this.assignedValueTitle=this.$ml.get('SELECT')
            this.activityId='',
            this.activities={},
            this.returnCustomField=[],
            this.activityTypeText="",
            this.activityDateWorkflow=""
            this.activityTime=this.$moment(new Date()).format("HH:mm")
            this.activityPeriod="00:00"
            this.selectedDone="",
            this.isHiddenOrganization=false,
            this.isHiddenContact=false,
            this.isHiddenDeal=false,
            this.items=[],
            this.activities['note']="",
            this.activityTypes('call'),
            this.assignedToValue="0",
            this.assignedValue="0",
            this.createDate="",
            this.selected=undefined,
            this.notes=[],
            this.customFieldType=undefined

            if(this.$route.path!="/dealCard/"+this.$route.params.dealId){
                this.dealKeyword=""
            }
            if(this.contactOrg===undefined && this.$route.path!="/dealCard/"+this.$route.params.dealId){
                this.contactKeyword=""
            }

            this.reminders=[
                {
                    day:'',
                    time:'12:00',
                    date:{$date:''},
                    isActive:true,
                    isQueued:false
                }
            ],
            $('#activity-tab').tab('show');
        },
        clear(){
            this.assignedToValueTitle=this.$ml.get('SELECT')
            this.assignedValueTitle=this.$ml.get('SELECT')
            this.activities={},
            this.activityId="",
            this.returnCustomField=[],
            this.activityTypeText="",
            this.selectedDone="",
            this.organizationKeyword="",
            this.contactKeyword="",
            this.dealKeyword="",
            this.selectOrganization="",
            this.selectContact="",
            this.selectDeal="",
            this.isHiddenOrganization=false,
            this.isHiddenContact=false,
            this.isHiddenDeal=false,
            this.items=[],
            this.isNewOrganization=false
            this.organizationId="",
            this.contactId="",
            this.dealId="",
            this.activities['note']="",
            this.activityTypes('call'),
            this.assignedToValue="0",
            this.assignedValue="0",
            this.$store.state.editLine={},
            this.createDate="",
            this.selected=undefined,
            this.notes=[],
            this.customFieldType=undefined,
            this.activityDateWorkflow=this.$moment(new Date()).format()
            this.activityTime=this.$moment(new Date()).format("HH:mm")
            this.activityPeriod="00:00"

            this.reminders=[
                {
                    day:'',
                    time:'12:00',
                    date:{$date:''},
                    isActive:true,
                    isQueued:false
                }
            ],
            $('#activity-tab').tab('show');
        },

        combineDateAndTime(date, time) {
            var timeString = time.getHours() + ':' + time.getMinutes() + ':00';
            var ampm = time.getHours() >= 12 ? 'PM' : 'AM';
            var year = date.getFullYear();
            var month = date.getMonth() + 1; // Jan is 0, dec is 11
            var day = date.getDate();
            var dateString = '' + year + '-' + month + '-' + day;
            var datec = dateString + 'T' + timeString;
            var combined = new Date(datec);

            return combined;
        },
        routerRequest(field){
            if(field==="contact"){
                if(this.selectContact!==this.contactKeyword){
                    this.quickContact() 
                    this.isHiddenOrganization=false
                    this.isHiddenDeal=false 
                }
                if(this.contactKeyword===""){
                    this.quickContact() 
                }
            }

            if(field==="organization"){
                if(this.selectOrganization!==this.organizationKeyword){
                    this.quickOrganization()
                    this.isHiddenContact=false
                    this.isHiddenDeal=false 
                }
                if(this.organizationKeyword===""){
                    this.quickOrganization() 
                }
            }

            if(field==="deal"){
                if(this.selectDeal!==this.dealKeyword){
                    this.quickDeal()
                    this.isHiddenOrganization=false
                    this.isHiddenContact=false 
                }
                if(this.dealKeyword===""){
                    this.quickDeal() 
                }
            }
        },
        setResult(result,type){
            if(type==="contact"){
                if(result.sn!==undefined){
                    this.contactKeyword=result.n+ " "+ result.sn
                    this.selectContact=result.n+ " "+ result.sn
                }else{
                    this.contactKeyword=result.n
                    this.selectContact=result.n
                }
                this.isHiddenContact= false
                this.contactId=result._id.$oid
                if(result.organizationName!==undefined){
                    this.organizationId=result.organization.$oid
                    this.organizationKeyword=result.organizationName
                    this.selectOrganization=result.organizationName
                }
            }

            if(type==="organization"){
                this.organizationKeyword=result.name
                this.isHiddenOrganization= false
                this.organizationId=result._id.$oid
                this.selectOrganization=result.name
            }

            if(type==="deal"){
                this.dealKeyword=result.title
                this.isHiddenDeal = false
                this.dealId=result._id.$oid
                this.selectDeal=result.title
            }
        },
        quickDeal(){
             
            axios({
                method:'POST',
                url:'/quickFilterDeal',
                baseURL: this.baseUrl,
                data: {
                    dealName:this.dealKeyword,
                    organizationId:this.organizationId,
                    contactId:this.contactId
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                    this.items=res.data.content.deals
                    this.isHiddenDeal= true
                     
                }else{
                     
                }
            })
        },
        quickOrganization(){
             
            axios({
                method:'POST',
                url:'/quickFilterOrganization',
                baseURL: this.baseUrl,
                data: {
                    search:this.organizationKeyword,
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                    this.items=res.data.content.organizations
                    this.isHiddenOrganization= true
                     
                }else{
                     
                }
            })
        },
        quickContact(){
            let obj = {}
            if(this.isNewOrganization){
                obj["search"]=this.contactKeyword
            }else{
                obj["search"]=this.contactKeyword
                obj["organizationId"]=this.organizationId
            }
            axios({
                method:'POST',
                url:'/quickFilterContact',
                baseURL: this.baseUrl,
                data: obj,
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                    this.items=res.data.content.contacts
                    if(this.contactKeyword!==''||this.organizationId!==''){
                        this.isHiddenContact= true
                    }
                     
                }else{
                     
                }
            })
        },
        dataFilling(updateData){
            if(!this.isEmpty(updateData)){
                if(updateData.edit){
                    if(updateData.subject!==undefined){
                        this.activities['subject']=updateData.subject
                    }
                    if(updateData.type!==undefined){
                        this.activities['type']=updateData.type
                        if(this.activities['type']===1){
                            this.activityTypes('call')
                        }else if(this.activities['type']===2){
                            this.activityTypes('meeting')
                        }else if(this.activities['type']===3){
                            this.activityTypes('task')
                        }else if(this.activities['type']===4){
                            this.activityTypes('email')
                        }
                    }

                    if(updateData.assignedTo!==undefined){
                        this.assignedToValue=updateData.assignedTo.$oid
                        this.assignedToValueTitle=this.users.find(usr => usr._id['$oid']==this.assignedToValue).name+" "+this.users.find(usr => usr._id['$oid']==this.assignedToValue).surName
                    }
                    if(updateData.assignor!==undefined){
                        this.assignedValue=updateData.assignor.$oid
                        this.assignedValueTitle=this.users.find(usr => usr._id['$oid']==this.assignedValue).name+" "+this.users.find(usr => usr._id['$oid']==this.assignedValue).surName
                    }
                    if(updateData.orgId!==undefined){
                        if(this.$route.path==="/organizationCard/"+this.$route.params.orgId&&updateData.notificationModal!==true){
                            if(updateData.orgId[0]!=undefined){
                                this.organizationId=updateData.orgId[0]._id.$oid  
                            }else{
                                this.organizationId=updateData.orgId.$oid
                            }
                        }else if(this.$route.path==="/contactCard/"+this.$route.params.contactId&&updateData.notificationModal!==true){
                            if(updateData.orgId[0]!=undefined){
                                this.organizationId=updateData.orgId[0]._id.$oid  
                            }else{
                                this.organizationId=updateData.orgId.$oid
                            }
                            this.organizationId=updateData.orgId.$oid
                            this.setResult(this.contactOrg,'organization')
                        }else{
                            this.organizationKeyword=updateData.orgId[0].name
                            this.organizationId=updateData.orgId[0]._id.$oid
                            this.selectOrganization=updateData.orgId[0].name
                        }
                    }
                    if(updateData.contactId!==undefined){
                        this.contactKeyword=updateData.contactId[0].n+" "+updateData.contactId[0].sn
                        this.isHiddenContact= false
                        this.contactId=updateData.contactId[0]._id.$oid
                        this.selectContact=updateData.contactId[0].n+" "+updateData.contactId[0].sn
                    }
                    if(updateData.dealId!==undefined && !this.isEmpty(updateData.dealId)){
                        if(this.$route.path==="/dealCard/"+this.$route.params.dealId){
                            this.dealId=updateData.dealId.$oid
                        }else{
                            this.dealKeyword=updateData.dealId[0].title
                            this.isHiddenDeal = false
                            this.dealId=updateData.dealId[0]._id.$oid
                            this.selectDeal=updateData.dealId[0].title
                        }
                        
                    }
                    if(updateData.notes!==undefined&&updateData.notes!==null){
                        if(typeof(updateData.notes)==="object"){
                            this.notes=updateData.notes
                            this.activitiesNote=""
                        }else{
                            this.activities['note']=""
                            this.activitiesNote=""
                        }
                        
                    }
                    if(updateData.duration!==undefined){
                        this.activityPeriod=updateData.duration
                    }
                    if(updateData.dueDate!==undefined){
                        this.activityDateWorkflow=this.$moment(updateData.dueDate.$date).format()
                        this.activityTime=this.$moment(updateData.dueDate.$date).format("HH:mm")
                    }
                    if(updateData.addDate!==undefined){
                        this.createDate=this.$moment(updateData.addDate.$date).format()
                    }
                    if(updateData._id.$oid!==undefined){
                        this.activityId=updateData._id.$oid
                    }
                    if(updateData.done!==undefined){
                        this.activities['done']=updateData.done
                    }
                }else{
                    console.log("updateData.notes")
                    console.log(updateData)
                    if(updateData.subject!==undefined){
                        this.activities['subject']=updateData.subject.val
                    }
                    if(updateData.type!==undefined){
                        this.activities['type']=updateData.type.val
                        if(this.activities['type']===1){
                            this.activityTypes('call')
                        }else if(this.activities['type']===2){
                            this.activityTypes('meeting')
                        }else if(this.activities['type']===3){
                            this.activityTypes('task')
                        }else if(this.activities['type']===4){
                            this.activityTypes('email')
                        }
                        this.customFieldType=updateData.type.val
                        this.customFieldActive=true
                    }
                    if(updateData.assignedTo!==undefined){
                        this.assignedToValue=updateData.assignedTo.val.$oid
                        this.assignedToValueTitle=this.users.find(usr => usr._id['$oid']==updateData.assignedTo.val.$oid).name+" "+this.users.find(usr => usr._id['$oid']==updateData.assignedTo.val.$oid).surName
                    }
                    if(updateData.assignor!==undefined){
                        this.assignedValue=updateData.assignor.val.$oid
                        this.assignedValueTitle=this.users.find(usr => usr._id['$oid']==updateData.assignor.val.$oid).name+" "+this.users.find(usr => usr._id['$oid']==updateData.assignor.val.$oid).surName
                    }
                    if(updateData.orgId.val!==null && updateData.orgId.val[0]!==undefined){
                        this.organizationKeyword=updateData.orgId.val[0].name
                        this.isHiddenOrganization= false
                        this.organizationId=updateData.orgId.val[0]._id.$oid
                        this.selectOrganization=updateData.orgId.val[0].name
                    }
                    if(updateData.contactId.val!==null && updateData.contactId.val[0]!==undefined){
                        this.contactKeyword=updateData.contactId.val[0].n+" "+updateData.contactId.val[0].sn
                        this.isHiddenContact= false
                        this.contactId=updateData.contactId.val[0]._id.$oid
                        this.selectContact=updateData.contactId.val[0].n+" "+updateData.contactId.val[0].sn
                    }
                    if(updateData.dealId.val!==null && !this.isEmpty(updateData.dealId.val[0])){
                        this.dealKeyword=updateData.dealId.val[0].title
                        this.isHiddenDeal = false
                        this.dealId=updateData.dealId.val[0]._id.$oid
                        this.selectDeal=updateData.dealId.val[0].title
                    }
                    if(updateData.notes.val!==undefined&&updateData.notes.val!==null){
                        this.notes=updateData.notes.val
                        this.activitiesNote=""
                    }
                    if(updateData.duration!==undefined){
                        this.activityPeriod=updateData.duration.val
                    }
                    if(updateData.dueDate!==undefined){
                        this.activityDateWorkflow=this.$moment(updateData.dueDate.val.$date).format()
                        this.activityTime=this.$moment(updateData.dueDate.val.$date).format("HH:mm")
                    }
                    if(updateData.addDate!==undefined){
                        this.createDate=this.$moment(updateData.addDate.val.$date).format()
                    }
                    if(updateData._id.val.$oid!==undefined){
                        this.activityId=updateData._id.val.$oid
                    }
                    if(updateData.done!==undefined){
                        this.activities['done']=updateData.done.val
                    }
                }
                this.getRemindersF()
            } 
        },
        isEmpty(obj) {
            if (obj == null) return true;
            if (obj.length > 0)    return false;
            if (obj.length === 0)  return true;
            if (typeof obj !== "object") return true;
            for (var key in obj) {
                if (hasOwnProperty.call(obj, key)) return false;
            }

            return true;
        },

        ...mapActions([
            'updateLoading',
            'getReminders',
            'upsertReminder'
        ]),
    },

    mounted(){
        $(".mincrm-dynamic-tabs").bootstrapDynamicTabs();
        if(Object.keys(this.updateAction).length !== 0){

            this.activitySubject=this.updateAction.activityInputObj.subject
            this.activityNote=this.updateAction.activityInputObj.note

            if(this.updateAction.activityInputObj.assignedTo!==undefined){
                this.assignedToValue=this.updateAction.activityInputObj.assignedTo.$oid
                this.assignedToValueTitle=this.users.find(usr => usr._id['$oid']==this.assignedToValue).name+" "+this.users.find(usr => usr._id['$oid']==this.assignedToValue).surName
            }
            if(this.updateAction.activityInputObj.assignor!==undefined){
                this.assignedValue=this.updateAction.activityInputObj.assignor.$oid
                this.assignedValueTitle=this.users.find(usr => usr._id['$oid']==this.assignedValue).name+" "+this.users.find(usr => usr._id['$oid']==this.assignedValue).surName
            }
            if(this.updateAction.activityInputObj.dueDatebyTime!==undefined){
                this.pickedActivityDate='fromCreationDate'
                let time=this.updateAction.activityInputObj.dueDatebyTime
                this.activityDelayDay=Math.floor(time/(60*24)) 
                this.activityDelayHour=Math.floor((time-(this.activityDelayDay*(60*24)))/60)
                this.activityDelayMinute=time-(this.activityDelayHour*60)-(this.activityDelayDay*(60*24)) 
            }
            if(this.updateAction.activityInputObj.duration!==undefined){
                this.activityTime1=this.updateAction.activityInputObj.duration
            }
            let activityType=this.updateAction.activityInputObj.type
            if(activityType==1){
                this.activityTypes('call')
            }
            else if(activityType==2){
                this.activityTypes('meeting')
            }
            else if(activityType==3){
                this.activityTypes('task')
            }
            else if(activityType==4){
                this.activityTypes('email')
            }
        }

    },
    
    created(){
        this.clear()
        this.customFieldType=undefined
        this.assignedToValue="0"
        this.assignedValue="0"
        this.activityDateWorkflow= ""
        this.activityTime1=""
        this.activityTime2=""
    },
    watch: {
        '$route': 'path',
        organizationKeyword: _.debounce(function(addr) {
            this.addOrgArray['name']=this.organizationKeyword
            this.closeOrgButton()
            if(this.selectOrganization!==this.organizationKeyword && this.organizationKeyword.length!==0){
                this.quickOrganization()
                this.isHiddenContact=false
                this.isHiddenDeal=false 
            }
            if(this.organizationKeyword===""){
                this.isHiddenOrganization= false
                this.organizationId=""
                delete this.activities["orgId"]
            } 
        }, 300),
        contactKeyword: _.debounce(function() {
            this.addContactArray['name']=this.contactKeyword
            this.closeContactButton()
            if(this.contactKeyword===""){
                this.isHiddenContact= false
                delete this.activities["contactId"]
            } 
            if(this.selectContact!==this.contactKeyword && this.contactKeyword.length!==0){
                this.quickContact() 
                this.isHiddenOrganization=false
                this.isHiddenDeal=false 
            }
        }, 300),
        dealKeyword: _.debounce(function() {
            if(this.dealKeyword===""){
                this.dealId=""
                this.isHiddenDeal=false
                delete this.activities["dealId"]
            } 
            if(this.selectDeal!==this.dealKeyword && this.dealKeyword.length!==0){
                this.quickDeal()
                this.isHiddenOrganization=false
                this.isHiddenContact=false 
            }
        }, 300),
        
        listenState(data) {
            this.dataFilling(data)
        },
        listenStateStatus(data){
            if(data===false){
                this.$store.state.editLine=[]
                if(this.data===undefined){
                    this.clear()
                }else{
                    this.clearMethod2()
                }
            }
        },
        data:_.debounce(function(value) {
            if(value.name!==undefined){
                this.organizationKeyword=value.name
                this.isHiddenOrganization= false
                this.organizationId=value._id.$oid
                this.selectOrganization=value.name
                let obj ={}
                obj["$oid"]=value._id.$oid
                this.activities["orgId"]=obj
                
                this.dealKeyword=""

                if(value.contacts!==undefined){
                    if(value.contacts.length===1){
                        this.isHiddenContact= false
                        this.contactId=value.contacts[0]._id.$oid

                        if(value.contacts[0].sn!==undefined){
                            this.contactKeyword=value.contacts[0].n+ " "+ value.contacts[0].sn
                            this.selectContact=value.contacts[0].n+ " "+ value.contacts[0].sn
                        }else{
                            this.contactKeyword=value.contacts[0].n
                            this.selectContact=value.contacts[0].n
                        }
                        let obj ={}
                        obj["$oid"]=value.contacts[0]._id.$oid
                        this.activities["contactId"]=obj
                        if(value.contacts[0].organization!==undefined){
                            this.organizationId=value.contacts[0].organization.$oid
                            this.organizationKeyword=value.name
                            this.selectOrganization=value.name
                        }
                    }
                    
                }
            }else if(value.title!==undefined){
                if(value.orgId!==undefined){
                    this.organizationKeyword=value.orgId.name
                    this.isHiddenOrganization= false
                    this.organizationId=value.orgId._id.$oid
                    this.selectOrganization=value.orgId.name
                    let obj ={}
                    obj["$oid"]=value.orgId._id.$oid
                    this.activities["orgId"]=obj
                }
                if(value!==undefined){
                    this.dealKeyword=value.title
                    this.isHiddenDeal = false
                    this.dealId=value._id.$oid
                    this.selectDeal=value.title
                    let obj ={}
                    obj["$oid"]=value._id.$oid
                    this.activities["dealId"]=obj
                }
                if(value.contactId!==undefined){
                    this.isHiddenContact= false
                    this.contactId=value.contactId._id.$oid
                    if(value.contactId.sn!==undefined){
                        this.contactKeyword=value.contactId.n+ " "+ value.contactId.sn
                        this.selectContact=value.contactId.n+ " "+ value.contactId.sn
                    }else{
                        this.contactKeyword=value.contactId.n
                        this.selectContact=value.contactId.n
                    }
                    let obj ={}
                    obj["$oid"]=value.contactId._id.$oid
                    this.activities["contactId"]=obj
                    if(value.contactId.organizationName!==undefined){
                        this.organizationId=value.contactId.organization.$oid
                        this.organizationKeyword=value.contactId.organizationName
                        this.selectOrganization=value.contactId.organizationName
                    }
                }
            }else{
                if(value!==undefined){
                    this.isHiddenContact= false
                    this.contactId=value._id.$oid
                    if(value.sn!==undefined){
                        this.contactKeyword=value.n+ " "+ value.sn
                        this.selectContact=value.n+ " "+ value.sn
                    }else{
                        this.contactKeyword=value.n
                        this.selectContact=value.n
                    }
                    let obj ={}
                    obj["$oid"]=value._id.$oid
                    this.activities["contactId"]=obj
                    this.dealKeyword=""
                }
            }
        }),
        contactOrg:_.debounce(function(value) {
            if(value!==undefined){
                this.organization=value
                this.organizationId=this.organization._id.$oid
                this.organizationKeyword=this.organization.name
                this.selectOrganization=this.organization.name
            }
        }),
        clearModal:function(val){
            if(val){                
                if(this.data===undefined){
                    this.clear()
                }else{
                    this.clearMethod2()
                }
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal-section{
    background-color:#D7E3F4;
}
.modal-section li {
  font-size: 14px;
  margin-right: 5px;
}
.modal-section li a {
color: #93959A;
text-decoration: none;
height: 100%;
display: flex;
align-items: center;
padding: 0 13px;
}
.modal-section li a.active {
  color: #5b5f63;
  font-weight: bold;
  border-bottom: 3px solid #1991EB;
}
.iptal:before{
    color:red
}
.clickable{
    cursor: pointer;
}
.done:hover{
    background-color: #66D0FF30;
}
.done.active{
    background-color: #66D0FF30;
    border: 1px solid #66D0FF
}
.activitiesType button{
    color: #3766a0;
    background-color: transparent;
    margin-right: 5px;
}
.activitiesType .active, .activitiesType button:hover {
    background-color: #3767A0;
    color: white;
}
.new-textarea{
    position: relative;
}

.new-textarea::placeholder {
  /* position: absolute;
  top: 50px;
  left: 15px;
  font-weight: normal;
  font-size: 13px; */
}

.textarea-icons{
    position: absolute;
    content: '';
    top: 50px;
    left: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.textarea-icons ul{
    display: flex;
    align-items: center;
    margin: 0;
    padding: 0;
}
.textarea-icons ul li{
    list-style: none;
    margin-left: 1rem;
}

@keyframes effect{
	0%{transform: scale(0);}
	25%{transform: scale(1.3);}
	75%{transform: scale(1.4);}
	100%{transform: scale(1);}
}
.previewNotes{
    max-height: 250px;
    overflow-y: auto;
}
.font-family-select{
    border: none;
    background-color: transparent;
    outline: none;
}


@media (max-width: 768px) {
    .activitiesType button{
        font-size: 14px;
        color: #7E8086;
    }
}
</style>

